import { Injectable } from '@angular/core';

@Injectable()
export class CookiesService {
  get(cname) {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  set(cname, cvalue, exmins) {
    const d = new Date();
    d.setTime(d.getTime() + exmins * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
  }

  delete(cname) {
    document.cookie = `${cname}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
  }
}



// WEBPACK FOOTER //
// ./src/app/service/cookies.service.ts